import {
  DotsFourIcon,
  IconButton,
  IconSizeEnum,
  useIsMobile,
  useOutsideClick,
} from '@acceso/design-system';
import { Popover, Transition } from '@headlessui/react';
import clsx from 'clsx';
import { useRef } from 'react';

import { PlatformsSwitcherMenu } from '../PlatformsSwitcherMenu/PlatformsSwitcherMenu';

type PlatformSwitcherProps = {
  showPlatformsSwitcher: boolean;
  popoverPosition?: 'top' | 'bottom';
  onShowPlatformsSwitcherChange: (show: boolean) => void;
};

export function PlatformSwitcher({
  showPlatformsSwitcher,
  onShowPlatformsSwitcherChange,
  popoverPosition = 'bottom',
}: PlatformSwitcherProps) {
  const isMobile = useIsMobile();
  const platformSwitcherButtonRef = useRef<HTMLButtonElement>(null);

  useOutsideClick({
    ref: platformSwitcherButtonRef,
    handler: () => onShowPlatformsSwitcherChange(false),
  });

  if (isMobile) {
    return (
      <div className="relative">
        <IconButton
          ref={platformSwitcherButtonRef}
          className="border border-stroke-40"
          onClick={() => onShowPlatformsSwitcherChange(!showPlatformsSwitcher)}
        >
          <DotsFourIcon className="text-[white]" size={IconSizeEnum.SM} />
        </IconButton>
        {showPlatformsSwitcher && (
          <div className="absolute right-[-15px] top-[38px] min-w-[184px] max-w-[300px] rounded-md bg-neutral-00 shadow">
            <PlatformsSwitcherMenu />
          </div>
        )}
      </div>
    );
  }

  return (
    <Popover className="relative">
      <IconButton
        ref={platformSwitcherButtonRef}
        className="border border-stroke-40"
        onClick={() => onShowPlatformsSwitcherChange(!showPlatformsSwitcher)}
      >
        <DotsFourIcon className="text-[white]" size={IconSizeEnum.SM} />
      </IconButton>

      <Transition
        show={showPlatformsSwitcher}
        as={Popover.Panel}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
        className={clsx(
          'absolute min-w-[184px] max-w-[300px] bg-neutral-00 p-size-16 shadow',
          popoverPosition === 'bottom'
            ? 'right-[-15px] top-[38px] rounded-b-md'
            : 'bottom-full left-0 mb-2 rounded-md'
        )}
      >
        <PlatformsSwitcherMenu />
      </Transition>
    </Popover>
  );
}
